/**
 * One-time vs subscription cart adds.
 * Shopify merges lines by variant + selling_plan + properties, and cart UI
 * previously keyed subscription state by variant_id. Tag one-time lines and
 * strip selling plans that apps re-apply onto them.
 */
(function (window) {
  var ONCE_TITLE = /1\s*time|one[\s-]*time|buy\s*once/i;
  var sanitizing = false;

  function cartAddUrl() {
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    if (url.indexOf('.js') === -1) url += '.js';
    return url;
  }

  function cartChangeUrl() {
    var url = (window.routes && window.routes.cart_change_url) || '/cart/change';
    if (url.indexOf('.js') === -1) url += '.js';
    return url;
  }

  function cartUpdateUrl() {
    var url = (window.routes && window.routes.cart_update_url) || '/cart/update';
    if (url.indexOf('.js') === -1) url += '.js';
    return url;
  }

  function jsonFetch(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Cart request failed');
        }
        return data;
      });
    });
  }

  function decoratePayload(payload) {
    var cart = document.querySelector('cart-drawer');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      payload.sections_url = window.location.pathname;
      cart.setActiveElement(document.activeElement);
    }
    return payload;
  }

  function isOnceItem(item) {
    var props = item && item.properties;
    return !!(props && props._amp_purchase === 'once');
  }

  function hasSellingPlan(item) {
    return !!(item && item.selling_plan_allocation && item.selling_plan_allocation.selling_plan);
  }

  function openCartDrawer() {
    var cart = document.querySelector('cart-drawer');
    if (cart && typeof cart.open === 'function') {
      cart.open();
    }
  }

  function refreshCartDrawer(parsedState) {
    var cart = document.querySelector('cart-drawer');
    if (!cart) return;

    if (typeof cart.renderContents === 'function' && parsedState && parsedState.sections) {
      cart.renderContents(parsedState);
      return;
    }

    if (parsedState && parsedState.sections && parsedState.sections['cart-drawer'] && typeof updateCartDrawer === 'function') {
      var html = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html');
      var next = html.querySelector('#CartDrawer');
      if (next) {
        updateCartDrawer(cart, next, false);
      }
    }

    openCartDrawer();
  }

  function publishCart(data) {
    if (typeof publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'amp-cart-atc',
        cartData: data
      });
    }
  }

  function sanitizeOnceLines() {
    if (sanitizing) return Promise.resolve(0);
    sanitizing = true;

    return fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var tainted = (cart.items || []).filter(function (item) {
          return isOnceItem(item) && hasSellingPlan(item);
        });
        if (!tainted.length) return 0;

        var chain = Promise.resolve(null);
        tainted.forEach(function (item, index) {
          chain = chain.then(function () {
            var body = {
              id: item.key,
              selling_plan: '',
              quantity: item.quantity
            };
            if (index === tainted.length - 1) {
              decoratePayload(body);
            }
            return jsonFetch(cartChangeUrl(), body);
          });
        });
        return chain.then(function (last) {
          if (last) refreshCartDrawer(last);
          return tainted.length;
        });
      })
      .catch(function (error) {
        console.warn('amp-cart-atc: could not restore one-time lines', error);
        return 0;
      })
      .then(function (count) {
        sanitizing = false;
        return count;
      });
  }

  function addOnce(variantId) {
    var payload = decoratePayload({
      id: Number(variantId),
      quantity: 1,
      properties: {
        _amp_purchase: 'once'
      }
    });

    return jsonFetch(cartAddUrl(), payload).then(function (data) {
      return sanitizeOnceLines().then(function (stripped) {
        if (!stripped) {
          refreshCartDrawer(data);
          publishCart(data);
        }
        return data;
      });
    }).catch(function (error) {
      if (error && /sold out/i.test(error.message) && window.ampSoldOut) {
        window.ampSoldOut.set(true);
      }
      throw error;
    });
  }

  function parsePlans(input) {
    try {
      return JSON.parse(input.getAttribute('data-amp-plans') || '[]');
    } catch (e) {
      return [];
    }
  }

  function pickPlanByPercent(input, percent) {
    var match = parsePlans(input).find(function (plan) {
      return Number(plan.percent) === Number(percent);
    });
    return match && match.id ? String(match.id) : '';
  }

  function useLineKey(payload, input) {
    var key = input.getAttribute('data-line-item-key');
    if (key) {
      payload.id = key;
      delete payload.line;
    }
    return payload;
  }

  function isBonusItem(item) {
    return !!(item && item.properties && item.properties._amp_purchase === 'bonus');
  }

  function hasThreePack(items) {
    return (items || []).some(function (item) {
      return !isBonusItem(item) && Number(item.quantity) >= 3;
    });
  }

  function applyBundleQuantityChange(payload, input, quantity) {
    var result = { removeBonus: false, addBonus: false, bonusId: '', bonusQty: 1 };
    if (!payload || !input) return result;
    var purchase = input.getAttribute('data-amp-purchase') || '';
    if (purchase === 'bonus' || purchase === 'once') return result;

    quantity = Number(quantity);
    var previous = parseInt(input.getAttribute('data-cart-quantity') || '0', 10);
    var hasPlan = input.getAttribute('data-amp-has-plan') === 'true';
    var isSubscribe = input.getAttribute('data-amp-purchase') === 'subscribe';
    if (!hasPlan && !isSubscribe) return result;

    if (previous >= 3 && quantity < 3) result.removeBonus = true;
    if (previous < 3 && quantity >= 3) {
      result.bonusId = input.getAttribute('data-amp-bonus-id') || '';
      result.bonusQty = parseInt(input.getAttribute('data-amp-bonus-qty') || '1', 10) || 1;
      result.addBonus = !!result.bonusId;
    }

    if (quantity < 1) return result;

    var targetPercent = 20;
    if (quantity === 2) targetPercent = 25;
    else if (quantity >= 3) targetPercent = 30;

    var planId = pickPlanByPercent(input, targetPercent);
    if (planId) {
      payload.selling_plan = planId;
      payload.properties = {
        _amp_purchase: 'subscribe',
        _amp_bundle: String(quantity)
      };
      useLineKey(payload, input);
    }

    return result;
  }

  function applyOnceIfBundleReduced(payload, input, quantity) {
    applyBundleQuantityChange(payload, input, quantity);
    return payload;
  }

  function fetchCart() {
    var url = (window.routes && window.routes.cart_url) || '/cart';
    if (url.indexOf('.js') === -1) url += '.js';
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (response) {
      return response.json();
    });
  }

  function addBonusLine(cart, sections, bonusId, bonusQty) {
    bonusId = String(bonusId || '');
    bonusQty = parseInt(bonusQty, 10) || 1;
    if (!bonusId || !cart) return Promise.resolve(cart);
    if (!hasThreePack(cart.items)) return Promise.resolve(cart);
    if ((cart.items || []).some(isBonusItem)) return Promise.resolve(cart);

    var body = {
      items: [{
        id: Number(bonusId),
        quantity: bonusQty,
        properties: {
          _amp_purchase: 'bonus'
        }
      }]
    };
    if (sections && sections.length) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    } else {
      decoratePayload(body);
    }

    return jsonFetch(cartAddUrl(), body).then(function (added) {
      return fetchCart().then(function (full) {
        if (added && added.sections) full.sections = added.sections;
        return full;
      });
    }).catch(function (error) {
      console.warn('amp-cart-atc: could not add bonus line', error);
      return cart;
    });
  }

  function removeOrphanBonusLines(cart, sections) {
    if (!cart || hasThreePack(cart.items)) return Promise.resolve(cart);
    var bonuses = (cart.items || []).filter(isBonusItem);
    if (!bonuses.length) return Promise.resolve(cart);

    var updates = {};
    bonuses.forEach(function (item) {
      updates[item.key] = 0;
    });

    var body = { updates: updates };
    if (sections && sections.length) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    } else {
      decoratePayload(body);
    }

    return jsonFetch(cartUpdateUrl(), body).catch(function (error) {
      console.warn('amp-cart-atc: could not remove bonus line', error);
      return cart;
    });
  }

  function pickOnceVariantId(product, fallbackId) {
    var variants = (product && product.variants) || [];
    var available = variants.filter(function (variant) {
      return variant.available !== false;
    });
    var once = available.find(function (variant) {
      var title = variant.title || variant.option1 || '';
      return ONCE_TITLE.test(title);
    });
    if (once) return String(once.id);
    if (fallbackId) {
      var fallback = available.find(function (variant) {
        return String(variant.id) === String(fallbackId);
      });
      if (fallback) return String(fallback.id);
    }
    return available[0] ? String(available[0].id) : '';
  }

  function bindSanitizeOnCartUpdate() {
    if (window.__ampCartAtcSanitizeBound) return;
    window.__ampCartAtcSanitizeBound = true;

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'amp-cart-atc') return;
        sanitizeOnceLines();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindSanitizeOnCartUpdate);
  } else {
    bindSanitizeOnCartUpdate();
  }

  window.ampCartAtc = {
    addOnce: addOnce,
    sanitizeOnceLines: sanitizeOnceLines,
    pickOnceVariantId: pickOnceVariantId,
    applyOnceIfBundleReduced: applyOnceIfBundleReduced,
    applyBundleQuantityChange: applyBundleQuantityChange,
    addBonusLine: addBonusLine,
    removeOrphanBonusLines: removeOrphanBonusLines
  };
})(window);
